import { MaatNcqManagerDetermination as SERVICE_WORKER_MaatNcqManagerDetermination } from '../../../../ServiceWorker/src/constants/maat-ncq-manager-determination.constants';

export { SERVICE_WORKER_MaatNcqManagerDetermination as MaatNcqManagerDetermination };